const initialState = {
  editCustomer: null,
};

const customer = (state = initialState, action) => {
  switch (action.type) {
    case 'EDIT_CUSTOMER':
      return {
        ...state,
        editCustomer: action.data,
      };

    default:
      return state;
  }
};

export default customer;
